import { Injectable } from '@angular/core';
import {
  HttpClient,
  HttpHeaders,
  HttpErrorResponse,
} from '@angular/common/http';
import {
  catchError,
  delay,
  map,
  Observable,
  retry,
  retryWhen,
  scan,
  switchMap,
  takeWhile,
  tap,
  throwError,
  timer,
  take,
  filter,
  EMPTY,
  timeout, 
  of
} from 'rxjs';

import { LoginService } from '../home/login.service';
import { IOnlineOrder } from './onlineorder';
import { ICartItems } from './cartitems';
import { IProduct } from '../products/product';
import { ToastrService } from 'ngx-toastr';
import { IOrderTotals } from './ordertotals';
import { ILatestOnlineOrder } from './latestonlineorder';
import { Buffer } from 'buffer';
import { INuveiOpenOrderResponse } from './nuveiopenorderresponse';
import { INuveiTransactionResponse } from './nuveiPaymentResponse';
import { INuveiPaymentStatusResponse } from './nuveiGetPaymentStatusResponse';
import { IDmnResult } from './nuveiDMNResponse';
import { INuveiItems } from './nuveiitems';
import { INuveiInitSessionResponse } from './NuveiInitSessionResponse';
import { NgxSpinnerService } from 'ngx-spinner';
import { AdminService } from '../admin/admin.service';
import { TranslateService } from '@ngx-translate/core';
import { ApiCacheService } from '../core/api-cache.service';
@Injectable()
export class OnlineOrderService {
  private body;
  public token!: string;
  public orderID!: number;
  public tempCart: ICartItems[] = [];
  public cart: ICartItems[] = [];
  public orderTotals!: IOrderTotals;
  public BalanceDue!: number;
  public TaxTotal!: number;
  public nvItems: INuveiItems[] = [];
  public BalanceDue2!: number;
  public TaxTotal2!: number;
  public currentUser: any;
  public lbriAPI: any;
  public caption: string;
  public transErrMsg: string;
  public baseUrl: string = 'https://samplecart.lbri.net/api/';
  translatedText = '';
  constructor(
    private _http: HttpClient,
    private login: LoginService,
    public toaster: ToastrService,
    public translate: TranslateService,
    public admin: AdminService,
    public spinner: NgxSpinnerService,
    private cache: ApiCacheService
  ) {}

  private _orderUrl!: string;
  private _orderUrl2!: string;
  private getTotalsUrl!: string;
  private _clearOrder!: string;

  // private _headers = new Headers({'Content-Type': 'application/json'});

  // addItemError(): void {

  //     this.toaster.error("You can only add one of each sample to your cart!", "Error",  {
  //         timeOut: 3000
  //     });
  // }
  // moreThanOneSampleError(): void{
  //     this.toaster.error("You can only order one sample set per order", "Error",  {
  //         timeOut: 3000
  //     });
  // }
  // addItemAlreadyOrderedError(): void {

  //     this.toaster.error("You have already ordered this item in the past, you can only order one free sample set " +
  //     "of each kind in your life time.", "Error",  {
  //             timeOut: 3000
  //         });
  // }
  getLocale(): any {
    var currentLocale = localStorage.getItem('locale');
    return currentLocale;
  }
  googleTranslateCall(textToTrans: string, targetLang: string): string {
    let model = {
      q: [textToTrans],
      target: targetLang,
    };
    this.admin.googleTranslate(model).subscribe((response: any) => {
      //console.log('Translate Call: ' + response.data.translations[0].translatedText);
      this.translatedText = response.data.translations[0].translatedText;
      return this.translatedText;
    });
    return '';
  }
  showError(errorMessage: string, subject: string, staticErrorMsg: boolean) {
    //use this for dynamic error messages
    if (staticErrorMsg === false) {
      let locale = this.getLocale();
      if (locale !== 'en') {
        //were gonna do it nested, couldn't do it as a standalone method.
        let model = {
          q: [errorMessage],
          target: locale,
        };

        this.admin.googleTranslate(model).subscribe(
          (response: any) => {
            let res = response.data.translations[0].translatedText as string;
            this.translatedText = response.data.translations[0]
              .translatedText as string;
            this.transErrMsg = this.translatedText;
            localStorage.setItem('translatedText', res);
          },
          (error) => console.log(error),
          () => {
            this.translate.get(subject).subscribe(
              (res: string) => {
                this.caption = res;
                console.log(res);
              },
              (error) => console.log(error),
              () => {
                this.spinner.hide();
                //once the caption is translated, fire off the toaster popup
                this.toaster.error(this.transErrMsg, this.caption, {
                  timeOut: 5000,
                });
                localStorage.removeItem('translatedText');
              }
            );
          }
        );

        //this.transErrMsg =  this.translatedText;
      } else {
        this.translate.get(subject).subscribe(
          (res: string) => {
            this.caption = res;
            console.log(res);
          },
          (error) => console.log(error),
          () => {
            this.transErrMsg = errorMessage;
            this.spinner.hide();
            //once the caption is translated, fire off the toaster popup
            this.toaster.error(this.transErrMsg, this.caption, {
              timeOut: 5000,
            });
            localStorage.removeItem('translatedText');
          }
        );
      }
    } else {
      // translate the error message - not dynamic
      this.translate.get(errorMessage).subscribe((res: string) => {
        this.transErrMsg = res;
        console.log(res);
      });

      // translate the caption
      this.translate.get(subject).subscribe((res: string) => {
        this.caption = res;
        console.log(res);
      });
      this.spinner.hide();
      //show the toaster popup
      this.toaster.error(this.transErrMsg, this.caption, {
        timeOut: 5000,
      });
    }
  }
  repId(): any {
    var currentId = localStorage.getItem('repId');
    return currentId;
  }

  // checkIfOrdered(sku: string) {
  //     this.lbriAPI = JSON.parse(localStorage.getItem('lbriToken') || '{}');
  //     let headers = new HttpHeaders({
  //         'scope': 'write',
  //         // 'content-type': 'application/x-www-form-urlencoded'
  //         'Authorization': "Bearer " + this.lbriAPI.access_token
  //     });

  //     let options1 = {
  //         headers: headers
  //     };
  //     let _body = {
  //         CustomerId: this.currentUser.userName.replace('-->c_', ''),
  //         ProductId: sku
  //     }
  //     this._clearOrder = 'https://samplecart.lbri.net/api/api/CheckItemOrderedSS/";
  //     return this._http.post(this._clearOrder, _body, options1)
  //     .pipe(
  //         catchError(this.handleError)
  //     )

  // }

  checkIfOrdered2(sku: string) {
    this.currentUser = JSON.parse(
      localStorage.getItem('authorizationData') || '{}'
    );
    let headers = new HttpHeaders({
      scope: 'write',
      // 'content-type': 'application/x-www-form-urlencoded'
      Authorization: 'Bearer ' + this.currentUser.access_token,
    });
    let options1 = {
      headers: headers,
    };
    let _body = {
      customerDID: this.currentUser.userName.replace('-->c_', ''),
      productID: sku,
      startDate: 1 / 1 / 1990,
    };

    this._clearOrder =
      'https://webapi.securefreedom.com/Lbri/API/Order/Order/CustomerItemOrderedSinceDate?customerDID=' +
      this.currentUser.userName.replace('-->c_', '') +
      '&productID=' +
      sku +
      '&startDate=1/1/1990';
    return this._http
      .get(this._clearOrder, options1)
      .pipe(catchError(this.handleError));

    // .map((response: HttpResponse) => response.json())
    // .do(data => console.log('All: ' +  JSON.stringify(data)))
    // .catch(this.handleError);
  }

  deleteItem(item: ICartItems) {
    this.cart = this.cart.filter(
      (cartItem) => cartItem.ProductId !== item.ProductId
    );
    return this.cart;
  }
  clearCart() {
    var currentUser = JSON.parse(
      localStorage.getItem('authorizationData') || '{}'
    );
    this.login.token = currentUser && currentUser.access_token;
    if (this.login.loggedIn()) {
      this.cart = [];
      localStorage.removeItem('cartItems');
      this.clearOrder().subscribe(
        (order: any) => console.log(order),
        (error: any) => console.log(error),
        () => {
          this.updateShipMethodPlusTotals2().subscribe();
        }
      );
    } else {
      localStorage.removeItem('cartItems');
      this.cart = [];
    }
  }
  public addItem(item: ICartItems) {
    if (this.cart.length > 0) {
      if (
        this.cart.filter((cartItem) => cartItem.ProductId == item.ProductId)
          .length >= 1
      ) {
        //console.log(this.tempCart = this.cart.filter(cartItem => cartItem.productId == item.productId));
        this.showError(
          'products.toastPopups.errors.oneOfEach',
          'products.toastPopups.errors.titles.title1',
          true
        );
        return false;
        // this.tempCart = this.cart.filter(cartItem => cartItem.productId == item.productId);
        // this.tempCart.forEach(item1 => {
        //     item1.quantity+=1;
        //     item.quantity = item1.quantity;

        // });
        // this.deleteItem(item);
        // this.tempCart = [];
      } else {
        this.cart.push(item);
        //console.log(this.cart);
        return true;
      }
      //this.cart.push(item);
      //console.log(this.cart);
    } else {
      this.cart.push(item);
      //console.log(this.cart);
      return true;
    }
  }

  public getCart(): ICartItems[] {
    return this.cart;
  }

  //clear online order
  clearOrder() {
    this.currentUser = JSON.parse(
      localStorage.getItem('authorizationData') || '{}'
    );
    var currentOrderID = JSON.parse(localStorage.getItem('orderId') || '{}');
    let headers = new HttpHeaders({
      scope: 'write',
      // 'content-type': 'application/x-www-form-urlencoded'
      Authorization: 'Bearer ' + this.currentUser.access_token,
    });
    let options1 = {
      headers: headers,
    };
    let _body = {};
    this.orderID = currentOrderID.ID;
    this._clearOrder =
      'https://webapi.bydesign.com/Lbri/api/Order/OnlineOrder/Clear?onlineOrderId=' +
      this.orderID;

    return this._http.post(this._clearOrder, _body, options1).pipe(
      retryWhen((e) =>
        e.pipe(
          scan((errorCount, error) => {
            if (errorCount >= 3) {
              throw error;
            }
            return errorCount + 1;
          }, 0),
          delay(1000)
        )
      ),
      catchError(this.handleError)
    );
  }

  //different way of doing the clear order function
  clearOrderSync() {
    this.currentUser = JSON.parse(
      localStorage.getItem('authorizationData') || '{}'
    );
    var currentOrderID = JSON.parse(localStorage.getItem('orderId') || '{}');
    this._clearOrder =
      'https://webapi.bydesign.com/Lbri/api/Order/OnlineOrder/Clear?onlineOrderId=' +
      this.orderID;
    let xhr = new XMLHttpRequest();
    xhr.open('POST', this._clearOrder, false);
    xhr.setRequestHeader(
      'Authorization',
      'Bearer ' + this.currentUser.access_token
    );
    xhr.send();
    // this.headers = new Headers({
    //     'scope': 'write',
    //     // 'content-type': 'application/x-www-form-urlencoded'
    //     'Authorization': "Bearer " + this.currentUser.access_token
    // });
    // this.options1 = new RequestOptions({
    //     headers: this.headers
    // });

    // this.orderID = currentOrderID.ID;

    // return this._http.post(this._clearOrder, this._body, this.options1)
    //     .map((response: Response) => response.json())
    //     //.do(data => console.log('All: ' +  JSON.stringify(data)))
    //     .catch(this.handleError);
  }
  // updateShipMethodPlusTotals(){
  //     this.lbriAPI = JSON.parse(localStorage.getItem('lbriToken') || '{}');
  //     let headers = new HttpHeaders({
  //         'scope': 'write',
  //         'content-type': 'application/json',
  //         'authorization': "Bearer " + this.lbriAPI.access_token
  //     });
  //     let options1 = {
  //         headers: headers
  //     };

  //     this.getTotalsUrl = 'https://samplecart.lbri.net/api/api/OnlineOrderUpdateShipMethod/';
  //     let _body = {

  //     };
  //     var currentOrderID = JSON.parse(localStorage.getItem('orderId') || '{}');
  //     this.orderID = currentOrderID.ID;

  //     return this._http.post<IOrderTotals>(this.getTotalsUrl + this.orderID, _body, options1)
  //     .pipe(
  //         map(data => this.orderTotals = data),
  //         tap(data => {
  //             this.BalanceDue = data.balanceDueField;
  //             this.TaxTotal = data.taxTotalField;
  //             this.BalanceDue2 = data.balanceDue;
  //             this.TaxTotal2 = data.taxTotal;

  //             localStorage.setItem('orderInfo', JSON.stringify({ balanceDueField: this.BalanceDue, taxTotalField: this.TaxTotal, BalanceDue: this.BalanceDue2, TaxTotal: this.TaxTotal2 }))
  //             if (this.BalanceDue !== undefined) {
  //                 return 'Get Balance Due: ' + this.BalanceDue + 'Get Tax: ' + this.TaxTotal;
  //             }
  //             else {
  //                 return 'Get Balance Due: ' + this.BalanceDue2 + 'Get Tax: ' + this.TaxTotal2;
  //             }
  //         }),
  //         catchError(this.handleError)
  //     );
  // }

  updateShipMethodPlusTotals2() {
    this.currentUser = JSON.parse(
      localStorage.getItem('authorizationData') || '{}'
    );

    let headers = new HttpHeaders({
      scope: 'write',
      'content-type': 'application/json',
      Authorization: 'Bearer ' + this.currentUser.access_token,
    });
    let options1 = {
      headers: headers,
    };

    this.getTotalsUrl =
      'https://webapi.securefreedom.com/Lbri/API/Order/OnlineOrder/';
    let _body = {};
    var currentOrderID = JSON.parse(localStorage.getItem('orderId') || '{}');
    this.orderID = currentOrderID.ID;

    return this._http
      .put<IOrderTotals>(
        this.getTotalsUrl +
          this.orderID +
          '/UpdateShipMethod?ShipMethodID=1001',
        _body,
        options1
      )
      .pipe(
        map((data) => (this.orderTotals = data)),
        tap((data) => {
          this.BalanceDue = data.balanceDueField;
          this.TaxTotal = data.taxTotalField;
          this.BalanceDue2 = data.balanceDue;
          this.TaxTotal2 = data.taxTotal;

          localStorage.setItem(
            'orderInfo',
            JSON.stringify({
              balanceDueField: this.BalanceDue,
              taxTotalField: this.TaxTotal,
              BalanceDue: this.BalanceDue2,
              TaxTotal: this.TaxTotal2,
            })
          );
          if (this.BalanceDue !== undefined) {
            return (
              'Get Balance Due: ' +
              this.BalanceDue +
              'Get Tax: ' +
              this.TaxTotal
            );
          } else {
            return (
              'Get Balance Due: ' +
              this.BalanceDue2 +
              'Get Tax: ' +
              this.TaxTotal2
            );
          }
        }),
        catchError(this.handleError)
      );
  }

  latestOnlineOrder(forceRefresh = false) {
  // This endpoint is called frequently across the app (login, cart, checkout).
  // Cache briefly to dedupe navigation bursts.
  const rep = this.repId() || '';
  const cust = (this.login.getCustId() || '').replace('-->c_', '');
  const key = `latestOrder:${rep}:${cust}`;

  if (forceRefresh) {
    this.cache.delete(key);
  }

  return this.cache.get<ILatestOnlineOrder>(
    key,
    () => this.latestOnlineOrderUncached(),
    30_000
  );
}


  private latestOnlineOrderUncached() {
    this.currentUser = JSON.parse(
      localStorage.getItem('authorizationData') || '{}'
    );
    let headers = new HttpHeaders({
      scope: 'write',
      // 'content-type': 'application/x-www-form-urlencoded'
      Authorization: 'Bearer ' + this.currentUser.access_token,
    });
    let options1 = {
      headers: headers,
    };
    this._orderUrl2 =
      'https://webapi.bydesign.com/Lbri/api/order/OnlineOrder/latest?repDID=' +
      this.repId() +
      '&customerDID=' +
      this.login.getCustId().replace('-->c_', '') +
      '&country=USA&languageKey=en_US&cartConfigurationID=2';

    let _body = {};
    return this._http
      .post<ILatestOnlineOrder>(this._orderUrl2, _body, options1)
      .pipe(
        tap((data) => {
          if (data.ID) {
            this.orderID = data.ID;
            localStorage.setItem('orderId', JSON.stringify(data));
            return this.orderID;
          }
          return 0;
        }),

        retryWhen((e) =>
          e.pipe(
            scan((errorCount, error) => {
              if (errorCount >= 3) {
                throw error;
              }
              return errorCount + 1;
            }, 0),
            delay(1000)
          )
        ),
        catchError(this.handleError)
      );
  }

  mergeToOrder(i: number) {
    this.currentUser = JSON.parse(
      localStorage.getItem('authorizationData') || '{}'
    );
    let _body = {};
    let headers = new HttpHeaders({
      scope: 'write',
      // 'content-type': 'application/x-www-form-urlencoded'
      Authorization: 'Bearer ' + this.currentUser.access_token,
    });
    let options1 = {
      headers: headers,
    };

    var currentOrderID = JSON.parse(localStorage.getItem('orderId') || '{}');
    this.orderID = currentOrderID.ID;

    //console.log("i's place: " + + " length: " +this.cart.length)
    this._orderUrl =
      'https://webapi.bydesign.com/Lbri/api/Order/OnlineOrderDetail';
    this._orderUrl +=
      '?onlineOrderId=' +
      this.orderID +
      '&productId=' +
      this.cart[i].ProductId +
      '&quantity=' +
      this.cart[i].Quantity;
    return this._http
      .post(this._orderUrl, null, options1)
      .pipe(catchError(this.handleError));
  }

  changeMarketType() {
    this.currentUser = JSON.parse(localStorage.getItem('authorizationData'));
    let orderInfo = JSON.parse(localStorage.getItem('orderId'));
    var creds1 = Buffer.from('postcardapi:6TfC5RdX$$', 'utf8').toString(
      'base64'
    );

    let myHeaders = new HttpHeaders({
      scope: 'write',
      // 'Authorization': "Bearer " + this.currentUser.access_token
      Authorization: 'Basic ' + creds1,
    });

    let httpOptionsNew = {
      headers: myHeaders,
    };

    let url =
      'https://webapi.bydesign.com/Lbri/api/order/OnlineOrder/' +
      orderInfo.ID +
      '/UpdateMarketShow?marketShowID=555';

    let _body2 = {};
    return this._http.post(url, _body2, httpOptionsNew).pipe(
      retryWhen((e) =>
        e.pipe(
          scan((errorCount, error) => {
            if (errorCount >= 3) {
              throw error;
            }
            return errorCount + 1;
          }, 0),
          delay(1000)
        )
      ),
      catchError(this.handleError)
    );
  }
  addToOrder(sku: string) {
    this.currentUser = JSON.parse(
      localStorage.getItem('authorizationData') || '{}'
    );
    let _body = {};
    let headers = new HttpHeaders({
      scope: 'write',
      // 'content-type': 'application/x-www-form-urlencoded'
      Authorization: 'Bearer ' + this.currentUser.access_token,
    });
    let options1 = {
      headers: headers,
    };

    var currentOrderID = JSON.parse(localStorage.getItem('orderId') || '{}');
    this.orderID = currentOrderID.ID;
    this._orderUrl =
      'https://webapi.bydesign.com/Lbri/api/Order/OnlineOrderDetail';
    this._orderUrl +=
      '?onlineOrderId=' +
      this.orderID +
      '&productId=' +
      sku +
      '&quantity=1&shouldCalculateTax=true';
    return this._http
      .post<IOnlineOrder[]>(this._orderUrl, _body, options1)
      .pipe(catchError(this.handleError));
  }

  /// NUVEI STUFF
  getSessionToken() {
    const MAX_RETRIES = 4;          // total attempts = 1 + MAX_RETRIES
        const BASE_DELAY_MS = 400;      // 0.4s, 0.8s, 1.6s, 3.2s ...

    var lbriToken = JSON.parse(localStorage.getItem('lbriToken'));

    //console.log("LBRI TOKEN FROM GET SESSION TOKEN: " + lbriToken.access_token);
    let myHeaders = new HttpHeaders({
      scope: 'write',
      Authorization: 'Bearer ' + lbriToken.access_token,
    });

    let httpOptionsNew = {
      headers: myHeaders,
    };

    let url = 'https://samplecart.lbri.net/api/api/Nuvei/InitSession';
    return this._http.get<INuveiInitSessionResponse>(url, httpOptionsNew)
    .pipe(
      retry({
                    count: MAX_RETRIES,
                    delay: (error: HttpErrorResponse, retryCount: number) => {
                        // Retry only on transient failures
                        const status = error.status;
    
                        const isTransient =
                            status === 0 ||                 // network / CORS / DNS / offline
                            status === 429 ||               // rate limit
                            (status >= 500 && status < 600); // server errors
    
                        if (!isTransient) {
                            return throwError(() => error);
                        }
    
                        // exponential backoff with cap
                        const backoff = Math.min(BASE_DELAY_MS * Math.pow(2, retryCount - 1), 8000);
                        return timer(backoff);
                    }
                })
              );
  }

  createOpenOrder(sessionToken: string, amount: string) {

    

    this.currentUser = JSON.parse(localStorage.getItem('authorizationData'));
    let userTokenId =
      this.currentUser.userType === 'customer'
        ? 'C:' + this.currentUser.userName
        : 'R:' + this.currentUser.userName;
    var lbriToken = JSON.parse(localStorage.getItem('lbriToken'));
    // Need address info for nexio
    let shipInfo =
      JSON.parse(localStorage.getItem('validatedAddress')) !== null
        ? JSON.parse(localStorage.getItem('validatedAddress'))
        : JSON.parse(localStorage.getItem('originalAddress'));

    //Billing info is rep info
    let billingInfo = JSON.parse(localStorage.getItem('allCustInfo'));

    //need to get items here
    let orderInfo: ILatestOnlineOrder = JSON.parse(
      localStorage.getItem('orderId')
    );
    console.log(orderInfo);
    orderInfo.Items.forEach((item, index) => {
      let nvItem: INuveiItems = {
        ProductName: item.DisplayName,
        //Quantity: item,
        //Amount: "200"
        Quantity: item.Quantity.toString(),
        Amount: item.Price.toString(),
      };
      //console.log("Product: " + nvItem.ProductName);
      this.nvItems.push(nvItem);
      console.log("ITEM: " + nvItem.ProductName);
    });

    let myHeaders = new HttpHeaders({
      scope: 'write',
      Authorization: 'Bearer ' + lbriToken.access_token,
    });

    let httpOptionsNew = {
      headers: myHeaders,
    };
    this.body = {
      SessionToken: sessionToken,
      BillingAddress: {
        FirstName: billingInfo.FirstName,
        LastName: billingInfo.LastName,
        Street1: billingInfo.Street1,
        Street2: billingInfo.Street2,
        City: billingInfo.BillCity,
        State: billingInfo.BillState,
        ZipCode: billingInfo.PostalCode,
        Email: billingInfo.Email,
        Country: 'USA',
      },
      Items: this.nvItems,
      Email: billingInfo.Email,
      Amount: amount,
      ClientUniqueId: "OnlineOrderID:" + orderInfo.ID,
      UserTokenId: userTokenId,
    };
    let url = 'https://samplecart.lbri.net/api/api/Nuvei/OpenOrder';
    return this._http
      .post<INuveiOpenOrderResponse>(url, this.body, httpOptionsNew)
      .pipe(
        retryWhen((e) =>
          e.pipe(
            scan((errorCount, error) => {
              if (errorCount >= 3) {
                throw error;
              }
              return errorCount + 1;
            }, 0),
            delay(1000)
          )
        ),
        catchError(this.handleError)
      );
  }

  getPaymentStatus(
    sessionToken: string,
    openOrderRes: INuveiOpenOrderResponse
  ) {
    this.currentUser = JSON.parse(localStorage.getItem('authorizationData'));
    let userTokenId =
      this.currentUser.userType === 'customer'
        ? 'C:' + this.currentUser.userName
        : 'R:' + this.currentUser.userName;
    var lbriToken = JSON.parse(localStorage.getItem('lbriToken'));
    // Need address info for nexio
    //let shipInfo = JSON.parse(localStorage.getItem('validatedAddress')) !== null ? JSON.parse(localStorage.getItem('validatedAddress')) : JSON.parse(localStorage.getItem('originalAddress'));

    //Billing info is rep info
    //let billingInfo = JSON.parse(localStorage.getItem('repFullInfo'));

    //need to get items here
    //let orderInfo: ILatestOnlineOrder = JSON.parse(localStorage.getItem('orderId'));

    let myHeaders = new HttpHeaders({
      scope: 'write',
      Authorization: 'Bearer ' + lbriToken.access_token,
    });
    let httpOptionsNew = {
      headers: myHeaders,
    };
    this.body = {
      SessionToken: sessionToken,
      UserId: userTokenId,
      ClientRequestId: openOrderRes.ClientRequestId,
    };
    let url = 'https://samplecart.lbri.net/api/api/Nuvei/PaymentStatus2';
    return this._http
      .post<INuveiPaymentStatusResponse>(url, this.body, httpOptionsNew)
      .pipe(
        retryWhen((e) =>
          e.pipe(
            scan((errorCount, error) => {
              if (errorCount >= 3) {
                throw error;
              }
              return errorCount + 1;
            }, 0),
            delay(1000)
          )
        ),
        catchError(this.handleError)
      );
  }
  BDTCCStoreNuvei(r: INuveiTransactionResponse, ps: IDmnResult) {
    var lbriToken = JSON.parse(localStorage.getItem('lbriToken'));
    let orderInfo = JSON.parse(localStorage.getItem('orderId'));
    let merchantInfo = JSON.parse(localStorage.getItem('merchantInfoTemp'));
    var shipMethod = JSON.parse(localStorage.getItem('orderInfo'));

    let myHeaders = new HttpHeaders({
      scope: 'write',
      Authorization: 'Bearer ' + lbriToken.access_token,
    });

    let httpOptionsNew = {
      headers: myHeaders,
    };
    const randoToken = crypto.randomUUID(); 
    let url =
      'https://samplecart.lbri.net/api/api/OnlinePaymentsCC/BDTTokenizedNuvei?id=' +
      orderInfo.ID +
      '&cardType=' +
      r.CardType;

      this.body = {
        MerchantId: merchantInfo?.MerchantId ?? "",
        AuthCode: ps?.AuthCode ?? "",
        TotalAmount: shipMethod?.BalanceDue?.toString() ?? "0",
        TransactionId: r?.TransactionId ?? "",
        Status: r?.TransactionStatus ?? "",
        TransactionType: r?.TransactionType ?? "",
        CCNumber: r?.CcCardNumber ?? "",
        ExpMonth: r?.CcExpMonth ?? "",
        ExpYear: r?.CcExpYear ?? "",
        CardHolderName: ps?.CardHolderName ?? "",
        CardType: r?.CardType ?? "",
        LastFour: r?.Last4Digits ?? "",
        token: ps?.Token ?? "",
        referenceNumber: randoToken ?? "",
      };

    return this._http.post(url, this.body, httpOptionsNew).pipe(
      retryWhen((e) =>
        e.pipe(
          scan((errorCount, error) => {
            if (errorCount >= 3) {
              throw error;
            }
            return errorCount + 1;
          }, 0),
          delay(1000)
        )
      ),
      catchError(this.handleError)
    );
  }

  calculateTax() {
    this.currentUser = JSON.parse(localStorage.getItem('authorizationData'));
    let _body = {
      name: null,
      value: null,
    };
    let myHeaders = new HttpHeaders({
      scope: 'write',
      Authorization: 'Basic ' + btoa('postcardapi:6TfC5RdX$$'),
    });
    let httpOptionsNew = {
      headers: myHeaders,
    };

    var currentOrderID = JSON.parse(localStorage.getItem('orderId'));
    this.orderID = currentOrderID.ID;
    this._orderUrl =
      'https://webapi.securefreedom.com/Lbri/api/Tax/CalculateTax?subjectTypeID=7&subjectID=';
    this._orderUrl += this.orderID;
    return this._http.post(this._orderUrl, null, httpOptionsNew).pipe(
      //map((response: Response) => console.log(response)),
      retryWhen((e) =>
        e.pipe(
          scan((errorCount, error) => {
            if (errorCount >= 3) {
              throw error;
            }
            return errorCount + 1;
          }, 0),
          delay(1000)
        )
      ),
      //retry(3),
      catchError(this.handleError)
    );
  }

  /**
   * Polls the Nuvei DMN listener for a transaction status every `intervalMs`
   * until `maxAttempts` is reached or status === 'APPROVED'
   */
  pollDmnStatus(
    transactionId: string,
    intervalMs = 5000,
    maxAttempts = 12
  ): Observable<any> {
    let attempts = 0;
    return timer(0, intervalMs).pipe(
      switchMap(() =>
        this._http.get(
          `https://samplecart.lbri.net/api/api/Nuvei/DmnStatus/${transactionId}`
        )
      ),
      takeWhile((res: any) => {
        attempts++;
        const done = res?.Status === 'APPROVED' || attempts >= maxAttempts;
        return !done;
      }, true) // emit last value too
    );
  }
// pollDmnStatus2(
//   transactionId: string,
//   initialDelayMs = 3000,
//   intervalMs = 5000,
//   maxAttempts = 18
// ): Observable<any> {
//   let attempts = 0;

//   return timer(initialDelayMs, intervalMs).pipe(
//     switchMap(() =>
//       this._http
//         .get(`https://samplecart.lbri.net/api/api/Nuvei/DmnStatus/${transactionId}`)
//         .pipe(
//           catchError((err) => {
//             // FIX: 404 means the DMN webhook hasn't arrived on the server yet.
//             // Treat it as PENDING and keep polling rather than throwing a fatal error.
//             // Status 0 covers network/CORS blips that should also be retried.
//             if (err.status === 404 || err.status === 0) {
//               console.warn(`DMN not ready yet (HTTP ${err.status}), retrying in ${intervalMs}ms...`);
//               return of({ Status: 'PENDING' });
//             }
//             // Anything else (401, 500, etc.) is a real error — let it propagate
//             // to the error handler in the component.
//             return throwError(() => err);
//           })
//         )
//     ),
//     takeWhile((res: any) => {
//       attempts++;
//       const isDone = res?.Status === 'APPROVED' || attempts >= maxAttempts;
//       return !isDone;
//     }, true) // true = emit the final value that caused takeWhile to stop
//   );
// }



pollDmnStatus2(
  transactionId: string,
  initialDelayMs = 3000,
  intervalMs = 5000,
  maxAttempts = 18
): Observable<any> {
  let attempts = 0;

  let token: string | null = null;
  try {
    const stored = JSON.parse(localStorage.getItem('lbriToken') || 'null');
    token = stored?.access_token ?? null;
  } catch {
    token = null;
  }

  if (!token) {
    // No valid session — don't start polling, surface this to the caller explicitly.
    return throwError(() => new Error('No auth token available for DMN polling'));
  }

  return timer(initialDelayMs, intervalMs).pipe(
    switchMap(() =>
      this._http
        .get(`https://samplecart.lbri.net/api/api/Nuvei/DmnStatus/${transactionId}`, {
          headers: { Authorization: `Bearer ${token}` }
        })
        .pipe(
          catchError((err) => {
            if (err.status === 404 || err.status === 0) {
              console.warn(`DMN not ready yet (HTTP ${err.status}), retrying in ${intervalMs}ms...`);
              return of({ Status: 'PENDING' });
            }
            return throwError(() => err);
          })
        )
    ),
    takeWhile((res: any) => {
      attempts++;
      const isDone = res?.Status === 'APPROVED' || attempts >= maxAttempts;
      return !isDone;
    }, true)
  );
}
  handleError(error: HttpErrorResponse) {
    let errorMessage = 'Unknown error!';
    if (error.error instanceof ErrorEvent) {
      // Client-side errors
      errorMessage = `Error: ${error.error.message}`;
    } else {
      // Server-side errors
      errorMessage = `Error Code: ${error.status}\nMessage: ${error.message}`;
    }
    //window.alert(errorMessage);
    return throwError(() => new Error(errorMessage));
  }
}
